// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"0d5d577d","6410":"b751597b","9322":"77ab36e7"}[chunkId] + ".chunk.css";
};